import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={17 * (props.wx ?? 1)}
    height={25 * (props.hx ?? 1)}
    viewBox="0 0 17 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <mask
      id="path-1-outside-1_2050_207"
      maskUnits="userSpaceOnUse"
      x="0.178955"
      y="0.280273"
      width="16"
      height="24"
      fill="black"
    >
      <rect fill="white" x="0.178955" y="0.280273" width="16" height="24" />
      <path d="M8.17872 1.85361C9.3776 1.85361 12.4953 0.340048 14.2961 2.23135C15.7392 3.74708 15.2062 7.39205 14.1718 9.84474C13.787 10.7574 13.7627 11.6258 13.779 12.6105C13.8546 17.2901 15.44 23.2781 14.3033 23.2803C13.1666 23.2824 11.6785 11.5203 8.17872 11.4003C4.67896 11.2803 5.17896 15.8003 4.67896 18.0003C4.17896 20.2003 3.49521 23.2803 2.80334 23.2803C2.11148 23.2803 2.18614 20.2003 2.18614 19.3203C2.18614 18.4403 2.53594 14.7041 2.48709 12.6105C2.46411 11.6258 2.5709 10.757 2.18614 9.84474C1.15171 7.39161 0.618714 3.74665 2.06178 2.23135C3.86258 0.340048 6.97985 1.85361 8.17872 1.85361Z" />
    </mask>
    <path
      d="M8.17872 1.85361C9.3776 1.85361 12.4953 0.340048 14.2961 2.23135C15.7392 3.74708 15.2062 7.39205 14.1718 9.84474C13.787 10.7574 13.7627 11.6258 13.779 12.6105C13.8546 17.2901 15.44 23.2781 14.3033 23.2803C13.1666 23.2824 11.6785 11.5203 8.17872 11.4003C4.67896 11.2803 5.17896 15.8003 4.67896 18.0003C4.17896 20.2003 3.49521 23.2803 2.80334 23.2803C2.11148 23.2803 2.18614 20.2003 2.18614 19.3203C2.18614 18.4403 2.53594 14.7041 2.48709 12.6105C2.46411 11.6258 2.5709 10.757 2.18614 9.84474C1.15171 7.39161 0.618714 3.74665 2.06178 2.23135C3.86258 0.340048 6.97985 1.85361 8.17872 1.85361Z"
      fill={props.fill || '#E4E4E7'}
    />
    <path
      d="M8.17872 1.85361C9.3776 1.85361 12.4953 0.340048 14.2961 2.23135C15.7392 3.74708 15.2062 7.39205 14.1718 9.84474C13.787 10.7574 13.7627 11.6258 13.779 12.6105C13.8546 17.2901 15.44 23.2781 14.3033 23.2803C13.1666 23.2824 11.6785 11.5203 8.17872 11.4003C4.67896 11.2803 5.17896 15.8003 4.67896 18.0003C4.17896 20.2003 3.49521 23.2803 2.80334 23.2803C2.11148 23.2803 2.18614 20.2003 2.18614 19.3203C2.18614 18.4403 2.53594 14.7041 2.48709 12.6105C2.46411 11.6258 2.5709 10.757 2.18614 9.84474C1.15171 7.39161 0.618714 3.74665 2.06178 2.23135C3.86258 0.340048 6.97985 1.85361 8.17872 1.85361Z"
      stroke={props.stroke || '#A1A1AA'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      mask="url(#path-1-outside-1_2050_207)"
    />
  </svg>
);
export default SvgNormal;
